<!-- TODO: Change translation keys to form fleet to users -->
@if (form(); as credentialsForm) {
  @let passwordControl = credentialsForm.controls.password;
  @let passwordInvalid = passwordControl.invalid && passwordControl.dirty;
  @let usernameErrorText = usernameError();

  <section class="flex--col gap-16 input-box" [formGroup]="credentialsForm">
    <div class="label text-14 fw-500 flex justify-space-between align-items-center">
      {{ 'users.form.input-label.login-credentials' | translate }}

      @if (!isEditMode()) {
        <i class="close clickable" (click)="closed.emit()">
          <app-icon-close
            [width]="16"
            [height]="16"
            [color]="'var(--color-gray-500)'"
          ></app-icon-close>
        </i>
      }
    </div>

    <div class="field-double gap-12 flex--col">
      <div class="flex gap-12">
        <div class="col">
          <app-prefixed-input
            formControlName="username"
            [prefix]="usernamePrefix() ?? ''"
            [placeholder]="'users.form.input-placeholder.username' | translate"
            [allowedInput]="'^[a-zA-Z0-9_-]+$'"
            [forceErrorState]="!!usernameError()"
          ></app-prefixed-input>
        </div>

        <div class="col">
          <input
            class="h--40 w100"
            formControlName="password"
            pInputText
            [placeholder]="
              (isEditMode()
                ? mode() === TYPES.UserFormMode.Fleet
                  ? 'users.form.input-placeholder.password-not-saved-fleet'
                  : 'users.form.input-placeholder.password-not-saved-tsp'
                : 'users.form.input-placeholder.password'
              ) | translate
            "
            type="text"
          />
        </div>
      </div>
    </div>

    @if (isEditMode()) {
      <p class="text-12 fw-400 color-gray-500">
        {{ 'users.form.password-hidden-info' | translate }}
      </p>
    }

    @if (passwordInvalid || usernameErrorText) {
      <div class="flex--col gap-8">
        @if (passwordInvalid) {
          <div class="errors-section">
            <div class="errors-section-icon">
              <app-icon-x-circle
                [width]="20"
                [height]="20"
                [color]="'var(--color-alert-500)'"
              ></app-icon-x-circle>
            </div>
            <div class="errors-section-text text-12 fw-400">
              <div class="mb-12">
                {{ 'users.form.errors.password-requirements-title' | translate }}
              </div>
              <ul class="errors-list">
                <li>
                  {{ 'users.form.errors.password-requirements-length' | translate }}
                </li>
                <li>
                  {{ 'users.form.errors.password-requirements-number' | translate }}
                </li>
                <li>
                  {{ 'users.form.errors.password-requirements-letter' | translate }}
                </li>
              </ul>
            </div>
          </div>
        }

        @if (usernameErrorText) {
          <div class="errors-section">
            <div class="errors-section-icon">
              <app-icon-x-circle
                [width]="20"
                [height]="20"
                [color]="'var(--color-alert-500)'"
              ></app-icon-x-circle>
            </div>
            <div class="errors-section-text text-12 fw-400">{{ usernameErrorText }}</div>
          </div>
        }
      </div>
    }

    <div class="message-text-panel">
      <app-icon-warning
        [height]="20"
        [width]="20"
        [color]="'var(--color-primary-500)'"
      ></app-icon-warning>
      <div class="text-12 fw-500 color-primary-500">
        @if (isEditMode()) {
          {{ 'users.form.share-credentials-warn' | translate }}
        } @else {
          {{ 'users.form.invitation-warn' | translate }}
        }
      </div>
    </div>
  </section>
}
